import apiClient from "@/shared/api/apiClient2";

function failure(label, e) {
  console.error(`[workflow/api] ${label}`, e);
  return {
    success: false,
    error: e?.response?.data || e?.message || String(e),
  };
}

export const getStatuses = async () => {
  try {
    const { data } = await apiClient.get("/template-action-rules/statuses");
    return data;
  } catch (e) {
    return failure("getStatuses", e);
  }
};

export const listRules = async (formTemplateUuid) => {
  try {
    const { data } = await apiClient.get("/template-action-rules/", {
      params: { form_template_uuid: formTemplateUuid },
    });
    return data;
  } catch (e) {
    return failure("listRules", e);
  }
};
